import React from "react"
import placeholder from "../images/placeholder.svg"

export const handleImageError = (event: React.SyntheticEvent<HTMLImageElement, Event>) => {
  event.currentTarget.src = placeholder
}
